import React from "react";
import { useTranslation } from "react-i18next";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";

function EinbindungInFundament({ einbindung_fundament = 0 }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("aeussre.embedmentLengthFoundation")}</p>}
      indicesValue={
        <span>
          K<sub>min</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={einbindung_fundament} />
        </span>
      }
      unitValue={<Millimetre />}
    />
  );
}

export default EinbindungInFundament;
